<template>
  <div class="tw-mb-2 tw-text-sm">
    <div
      v-if="hasLocated"
      class="tw-flex"
    >
      <div class="tw-mr-2 tw-font-sans tw-font-bold">
        To:
      </div>
      <span
        class="tw-underline tw-cursor-pointer"
        data-test="set-address"
        @click.prevent="$emit('setAddress')"
      >
        {{ address }}
      </span>
    </div>
    <div
      v-else
      class="tw-underline tw-cursor-pointer"
      data-test="set-address"
      @click.prevent="$emit('setAddress')"
    >
      Set Address
    </div>
  </div>
</template>
<script>
export default {  
  props: {
    hasLocated: {
      type: Boolean,
      required: true
    },
    address: {
      type: String,
      default: ''
    }
  }
}
</script>